"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = require("semantic-ui-react");

var _MilloraDades = require("./MilloraDades.css");

var _MilloraDades2 = _interopRequireDefault(_MilloraDades);

var _constants = require("../../utils/constants");

var CONSTANTS = _interopRequireWildcard(_constants);

var _request = require("../../common/request");

var _request2 = _interopRequireDefault(_request);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
//     

var dadesOptions = [{ key: 'tempsactual', text: 'Temps Actual', value: 'tempsactual' }, { key: 'meteodades', text: 'Meteodades', value: 'meteodades' }];

var urlOptions = [{ key: 'tempsactual', text: 'Temps Actual', value: 'dadesCAT_utc.csv' }, { key: 'meteodades', text: 'Meteodades', value: 'meteodades.csv' }];

var anyOptions = [{ key: '2020', text: '2020', value: '2020' }, { key: '2019', text: '2019', value: '2019' }, { key: '2018', text: '2018', value: '2018' }];

var any = new Date().getFullYear();
var anyMes = parseInt(any) - 2020;

for (var i = 0; i < anyMes; i++) {

  var newY = parseInt(any) + i;

  anyOptions.splice(0, 0, { key: newY.toString(), text: newY.toString(), value: newY.toString() });
}

var mesOptions = [{ key: '01', text: '01', value: '01' }, { key: '02', text: '02', value: '02' }, { key: '03', text: '03', value: '03' }, { key: '04', text: '04', value: '04' }, { key: '05', text: '05', value: '05' }, { key: '06', text: '06', value: '06' }, { key: '07', text: '07', value: '07' }, { key: '08', text: '08', value: '08' }, { key: '09', text: '09', value: '09' }, { key: '10', text: '10', value: '10' }, { key: '11', text: '11', value: '11' }, { key: '12', text: '12', value: '12' }];

var diaOptions = [{ key: '01', text: '01', value: '01' }, { key: '02', text: '02', value: '02' }, { key: '03', text: '03', value: '03' }, { key: '04', text: '04', value: '04' }, { key: '05', text: '05', value: '05' }, { key: '06', text: '06', value: '06' }, { key: '07', text: '07', value: '07' }, { key: '08', text: '08', value: '08' }, { key: '09', text: '09', value: '09' }, { key: '10', text: '10', value: '10' }, { key: '11', text: '11', value: '11' }, { key: '12', text: '12', value: '12' }, { key: '13', text: '13', value: '13' }, { key: '14', text: '14', value: '14' }, { key: '15', text: '15', value: '15' }, { key: '16', text: '16', value: '16' }, { key: '17', text: '17', value: '17' }, { key: '18', text: '18', value: '18' }, { key: '19', text: '19', value: '19' }, { key: '20', text: '20', value: '20' }, { key: '21', text: '21', value: '21' }, { key: '22', text: '22', value: '22' }, { key: '23', text: '23', value: '23' }, { key: '24', text: '24', value: '24' }, { key: '25', text: '25', value: '25' }, { key: '26', text: '26', value: '26' }, { key: '27', text: '27', value: '27' }, { key: '28', text: '28', value: '28' }, { key: '29', text: '29', value: '29' }, { key: '30', text: '30', value: '30' }, { key: '31', text: '31', value: '31' }];

var horaOptions = [{ key: '25', text: 'Hora 25', value: '25' }, { key: '00', text: '00:00', value: '00' }, { key: '01', text: '01:00', value: '01' }, { key: '02', text: '02:00', value: '02' }, { key: '03', text: '03:00', value: '03' }, { key: '04', text: '04:00', value: '04' }, { key: '05', text: '05:00', value: '05' }, { key: '06', text: '06:00', value: '06' }, { key: '07', text: '07:00', value: '07' }, { key: '08', text: '08:00', value: '08' }, { key: '09', text: '09:00', value: '09' }, { key: '10', text: '10:00', value: '10' }, { key: '11', text: '11:00', value: '11' }, { key: '12', text: '12:00', value: '12' }, { key: '13', text: '13:00', value: '13' }, { key: '14', text: '14:00', value: '14' }, { key: '15', text: '15:00', value: '15' }, { key: '16', text: '16:00', value: '16' }, { key: '17', text: '17:00', value: '17' }, { key: '18', text: '18:00', value: '18' }, { key: '19', text: '19:00', value: '19' }, { key: '20', text: '20:00', value: '20' }, { key: '21', text: '21:00', value: '21' }, { key: '22', text: '22:00', value: '22' }, { key: '23', text: '23:00', value: '23' }];

var CaptureValues = function (_Component) {
  _inherits(CaptureValues, _Component);

  function CaptureValues(props) {
    _classCallCheck(this, CaptureValues);

    //http://dinamics.ccma.cat/public/tests/tempsactual/2019/02/19/25/2019021925dadesCAT_utc.csv
    //	http://dinamics.ccma.cat/public/tests/meteodades/2019/10/07/22/2019100722meteodades.csv

    var _this = _possibleConstructorReturn(this, (CaptureValues.__proto__ || Object.getPrototypeOf(CaptureValues)).call(this, props));

    _this.state = { Dades: '', Any: '', Mes: '', Dia: '', Hora: '', Arxiu: '', submittedDades: '', submittedAny: '', submittedMes: '', submittedDia: '', submittedHora: '' };

    _this.handleChange = function (e, _ref) {
      var name = _ref.name,
          value = _ref.value;


      if (value === "tempsactual") {
        _this.setState(_defineProperty({
          Arxiu: urlOptions[0].value
        }, name, value));
      } else if (value === "meteodades") {
        _this.setState(_defineProperty({
          Arxiu: urlOptions[1].value
        }, name, value));
      } else {

        _this.setState(_defineProperty({}, name, value));
      }
    };

    _this.handleSubmit = function () {
      var _this$state = _this.state,
          Url = _this$state.Url,
          Dades = _this$state.Dades,
          Any = _this$state.Any,
          Mes = _this$state.Mes,
          Dia = _this$state.Dia,
          Hora = _this$state.Hora,
          Arxiu = _this$state.Arxiu;

      _this.setState({
        loading: true
      });
      // const paramUrl =`${Url}${Dades}/${Any}/${Mes}/${Dia}/${Hora}/${Any}${Mes}${Dia}${Hora}${Arxiu}`;


      if (Dades !== "" && Any !== "" && Mes !== "" && Dia !== "" && Hora !== "") {

        var paramUrl = "" + CONSTANTS.URL_UPDATEMEASURES + Dades + "/" + Any + "/" + Mes + "/" + Dia + "/" + Hora;

        _request2.default.get(paramUrl).then(function (data) {

          console.info(data);
          if (data.ok) {
            _this.setState({
              loading: false,
              showSuccess: true,
              succesMSG: data.message
            });
          } else {
            _this.setState({
              loading: false,
              showError: true,
              errorMsg: data.message
            });
          }
        }).catch(function (err) {
          console.info(err);
          //console.info(data);
          _this.setState({ loading: false, showError: true, errorMsg: err });
        });
      } else {

        alert("Falten paràmetres a la URL!!");
        _this.setState({ loading: false });
        return false;
      }
    };

    _this.state = {
      Url: "http://dinamics.ccma.cat/public/tests/",
      Dades: '',
      Any: '',
      Mes: '',
      Dia: '',
      Hora: '',
      Arxiu: '',
      submittedDades: '',
      submittedAny: '',
      submittedMes: '',
      submittedDia: '',
      submittedHora: '',
      loading: false,
      showSuccess: false,
      succesMSG: {},
      showError: false,
      errorMsg: {}
    };
    return _this;
  }

  _createClass(CaptureValues, [{
    key: "renderMSG",
    value: function renderMSG() {

      if (this.state.loading) {
        return _react2.default.createElement(
          _semanticUiReact.Loader,
          { size: "huge", active: true },
          "Actualitzantdades dades..."
        );
      } else if (this.state.showError) {

        return _react2.default.createElement(
          _semanticUiReact.Message,
          { negative: true },
          _react2.default.createElement(
            _semanticUiReact.Message.Header,
            null,
            "Error"
          ),
          _react2.default.createElement(
            "p",
            null,
            "Ha ocorregut un error: ",
            this.state.errorMsg
          )
        );
      } else if (this.state.showSuccess) {

        return _react2.default.createElement(
          _semanticUiReact.Message,
          { success: true },
          _react2.default.createElement(
            _semanticUiReact.Message.Header,
            null,
            "Sembla que tot ha anat b\xE9!!"
          ),
          _react2.default.createElement(
            "p",
            null,
            _react2.default.createElement(
              "strong",
              null,
              this.state.succesMSG
            )
          )
        );
      } else {

        return _react2.default.createElement("div", null);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _state = this.state,
          Url = _state.Url,
          Dades = _state.Dades,
          Any = _state.Any,
          Mes = _state.Mes,
          Dia = _state.Dia,
          Hora = _state.Hora,
          Arxiu = _state.Arxiu,
          submittedDades = _state.submittedDades,
          submittedAny = _state.submittedAny,
          submittedMes = _state.submittedMes,
          submittedDia = _state.submittedDia,
          submittedHora = _state.submittedHora;


      return _react2.default.createElement(
        "div",
        null,
        _react2.default.createElement(
          _semanticUiReact.Message,
          { info: true },
          _react2.default.createElement(
            _semanticUiReact.Message.Header,
            null,
            _react2.default.createElement(
              "p",
              null,
              "En aquesta p\xE0gina podr\xE0s recrear la URL on hi ha l'arxiu CSV amb les dades correctes."
            ),
            _react2.default.createElement(
              "p",
              null,
              "Un cop hagis creat la URL, utlitza el bot\xF3 \"Actualitzar\" per:"
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.List,
            { bulleted: true },
            _react2.default.createElement(
              _semanticUiReact.List.Item,
              null,
              "Esborrar les dades d'aquest periode dels servidors del ICGC"
            ),
            _react2.default.createElement(
              _semanticUiReact.List.Item,
              null,
              "Inserir les noves dades actualitzades als servidors del ICGC"
            )
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Form,
          { onSubmit: this.handleSubmit },
          _react2.default.createElement(
            _semanticUiReact.Form.Group,
            null,
            _react2.default.createElement(
              _semanticUiReact.Form.Group,
              { widths: "equal" },
              _react2.default.createElement(_semanticUiReact.Form.Field, {
                control: _semanticUiReact.Select,
                options: dadesOptions,
                label: { children: 'Producte', htmlFor: 'form-select-control-Dades' },
                placeholder: "Producte",
                search: true,
                searchInput: { id: 'form-select-control-Dades' },
                name: "Dades",
                value: Dades,
                onChange: this.handleChange

              }),
              _react2.default.createElement(_semanticUiReact.Form.Field, {
                control: _semanticUiReact.Select,
                options: anyOptions,
                label: { children: 'Any', htmlFor: 'form-select-control-any' },
                placeholder: "Any",
                search: true,
                searchInput: { id: 'form-select-control-any' },
                name: "Any",
                value: Any,
                onChange: this.handleChange
              }),
              _react2.default.createElement(_semanticUiReact.Form.Field, {
                control: _semanticUiReact.Select,
                options: mesOptions,
                label: { children: 'Mes', htmlFor: 'form-select-control-mes' },
                placeholder: "Mes",
                search: true,
                searchInput: { id: 'form-select-control-mes' },
                name: "Mes",
                value: Mes,
                onChange: this.handleChange
              }),
              _react2.default.createElement(_semanticUiReact.Form.Field, {
                control: _semanticUiReact.Select,
                options: diaOptions,
                label: { children: 'Dia', htmlFor: 'form-select-control-dia' },
                placeholder: "Dia",
                search: true,
                searchInput: { id: 'form-select-control-dia' },
                name: "Dia",
                value: Dia,
                onChange: this.handleChange
              }),
              _react2.default.createElement(_semanticUiReact.Form.Field, {
                control: _semanticUiReact.Select,
                options: horaOptions,
                label: { children: 'Hora', htmlFor: 'form-select-control-hora' },
                placeholder: "Hora",
                search: true,
                searchInput: { id: 'form-select-control-hora' },
                name: "Hora",
                value: Hora,
                onChange: this.handleChange
              })
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Form.Group,
            null,
            _react2.default.createElement(
              "div",
              null,
              _react2.default.createElement(
                "strong",
                null,
                "URL arxiu:"
              ),
              _react2.default.createElement("br", null),
              _react2.default.createElement(
                _semanticUiReact.Label,
                null,
                Url
              ),
              _react2.default.createElement(
                _semanticUiReact.Label,
                null,
                Dades
              ),
              "/",
              _react2.default.createElement(
                _semanticUiReact.Label,
                null,
                Any
              ),
              "/",
              _react2.default.createElement(
                _semanticUiReact.Label,
                null,
                Mes
              ),
              "/",
              _react2.default.createElement(
                _semanticUiReact.Label,
                null,
                Dia
              ),
              "/",
              _react2.default.createElement(
                _semanticUiReact.Label,
                null,
                Hora
              ),
              "/",
              _react2.default.createElement(
                _semanticUiReact.Label,
                null,
                "" + Any + Mes + Dia + Hora + Arxiu
              ),
              _react2.default.createElement(
                "a",
                { target: "blank", title: "Provar url", href: "" + Url + Dades + "/" + Any + "/" + Mes + "/" + Dia + "/" + Hora + "/" + Any + Mes + Dia + Hora + Arxiu },
                _react2.default.createElement(_semanticUiReact.Icon, { link: true, name: "external" })
              )
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Form.Group,
            null,
            _react2.default.createElement("br", null),
            _react2.default.createElement(_semanticUiReact.Form.Button, {
              content: "Actualitzar",
              className: _MilloraDades2.default.submitButton,
              color: "teal"
            })
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Button,
          { onClick: function onClick() {
              return _this2.props.tornaGestor();
            }, className: _MilloraDades2.default.btTornar, color: "red" },
          "Torna enrere"
        ),
        this.renderMSG()
      );
    }
  }]);

  return CaptureValues;
}(_react.Component);

exports.default = CaptureValues;


CaptureValues.propTypes = {
  tornaGestor: _propTypes2.default.func
};
